import {pdfjs} from "react-pdf"

/**
 * PDF.js document options for JPEG 2000 (OpenJPEG) support.
 * Fixes: "JpxError: OpenJPEG failed to initialize" when PDFs contain JPEG 2000 images.
 * In production, wasm is copied to dist/wasm/ by postbuild (copy-pdf-worker.js).
 * In development, use CDN so it works without a prior build.
 */
export const pdfDocumentOptions = {
	wasmUrl:
		typeof process !== "undefined" && process.env?.NODE_ENV === "development"
			? `https://unpkg.com/pdfjs-dist@${pdfjs.version}/wasm/`
			: "/wasm/",
} as const
